import React from "react";

const SignatureHeader = ({ text, signedBy, logoHeader, valid = true }) => {
  const color = valid ? "text-green-500" : "text-red-500";

  return (
    <div>
      <div className="mb-14 mt-14 items-center flex content-center justify-center object-center">
        <div>
          <p className="text-2xl font-normal text-gray-800 pb-2 text-center">
            {signedBy}
          </p>
          <div className="flex justify-center">{logoHeader}</div>
        </div>
      </div>
      <div className="m-5 mb-10">
        <h1 className={`text-3xl font-light ${color}`}>{text}</h1>
      </div>
    </div>
  );
};

export default SignatureHeader;
